
  angular.
  module('quantixApp').
  component('displayLabel', {
    template: '<span ng-if="$ctrl.labeltxt != null && $ctrl.labeltype != \'rating\'">{{$ctrl.labeltxt}}</span><span ng-if="$ctrl.labeltxt != null && $ctrl.labeltype == \'rating\'" ng-bind-html="$ctrl.getLabel()"></span><span ng-if="$ctrl.labeltxt == null && $ctrl.labeltype == \'rating\'" class="upload-fail">Unrated</span> <span ng-if="$ctrl.labeltxt == null && $ctrl.labeltype != \'rating\'" class="upload-fail">Not available</span>',
    bindings: {
      labeltxt: '<',
      labeltype: '<'
    },
    controller: function TooltipTemplateController() {
      var ctrl = this;

      ctrl.getLabel = function() {
        var day = parseInt(this.labeltxt.substr(0, 2));
        var suffix = 'th';
        if (day == 1 || day === 21 || day == 31) {
            suffix = 'st';
        }
        if (day == 2 || day == 22) {
            suffix = 'nd';
        }
        if (day == 3 || day == 23) {
           suffix = 'rd';
        }
        return day + '<sup>'+ suffix +'</sup>' + this.labeltxt.substr(2, this.labeltxt.length);
      }
    }
    
  });